import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

type TransmissionData = {
  totalRequired: number;
  totalCollected: number;
  totalNeeded: number;
  data?: { month: string; collected: number; needed: number }[];
};

type TransmissionRes = {
  status: string;
  data: TransmissionData;
};

const useTransmissionsData = () => {
  const [transmissionsData, setTransmissionsData] = React.useState<TransmissionData | undefined>();

  const { loading: transmissionsLoading, makeApiCall } = useApi({
    url: `/rtm/dashboard/transmission`, 
    method: "GET",
  });

  const getTransmissionsData = async () => {
    const { response, error } = await makeApiCall<undefined, TransmissionRes>();

    if (response?.status === "success") {
      setTransmissionsData(response.data);
    }

    if (!response?.status) {
      setTransmissionsData(undefined);
    }

    if (error) {
      toast.error("Failed to fetch transmission data. Please try again later.");
    }
  };

  return {
    transmissionsData,
    getTransmissionsData,
    transmissionsLoading,
  };
};

export default useTransmissionsData;
